import Joi from 'joi';

const validStatus = ['active', 'deleted'];

const schema = {
  sort: Joi.string().default('name-asc'),
  skip: Joi.number().default(0),
  limit: Joi.number().default(25),
  id: Joi.array().items(Joi.number()),
  query: Joi.string().allow(null, '').default(''),
  status: Joi.array()
    .items(Joi.string().valid(...validStatus))
    .default(['active']),
  linkedToSpotlight: Joi.boolean().default(false),
  linkedToWatch: Joi.boolean().default(false),
  notCreatedBySpotlight: Joi.boolean().default(false),
  affectedByMerge: Joi.boolean().default(false),
};

export default schema;
